import { Worker } from "../util";
export default class ObjednavkaRkHromadneCtrl {

  months = [
    "Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"
  ];

  constructor(OdberneMiestoService){
    this.OdberneMiestoService = OdberneMiestoService;
    this.importXls = Worker(this._importXls);
    this.save = Worker(this._save);
    this.file = null;
    this.orders = [];
  }

  onFile($file){
    this.file = $file;
  }

  _importXls(){
    return this.OdberneMiestoService.readRkXls(this.file).then(orders => this.orders = orders);
  }

  _save(){
    return this.OdberneMiestoService.orderRkBatch(this.orders);
  }

  cancel(){
    this.orders = [];
    this.save = Worker(this._save);
  }

  exportXls(){
    this.OdberneMiestoService.exportRk();
  }

  formatNumber(n){
    if(n === undefined){
      return undefined;
    }
    return (""+(+n).toFixed(3)).replace(".", ",");
  }

}


// WEBPACK FOOTER //
// ./src/RezervovanaKapacita/ObjednavkaRkHromadneCtrl.js